module.exports = __webpack_public_path__ + "img/answering.68950fe7.png";